import { CHANGE_ROUTE } from '@app/actions/_types';

export const changeRoute = (view, matrix) => ({
  type: CHANGE_ROUTE,
  payload: {
    matrix,
    view,
  },
});
